export default __webpack_public_path__ + "static/media/icon-setting-white.3382a6b4.svg";